import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "auth-form__title"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_3 = {
  key: 1,
  class: "auth-form__title"
}
const _hoisted_4 = {
  key: 2,
  class: "auth-form__subtitle"
}
const _hoisted_5 = {
  key: 3,
  class: "auth-form__subtitle"
}
const _hoisted_6 = { class: "flat-form" }
const _hoisted_7 = {
  key: 0,
  class: "system-alert danger"
}
const _hoisted_8 = { class: "system-alert__wrapper" }
const _hoisted_9 = {
  key: 1,
  class: "flat-form-login"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "flat-form-login_item" }, "Вход ", -1 /* HOISTED */)
const _hoisted_11 = { class: "dropdown dropdown-select dropdown-inline" }
const _hoisted_12 = {
  id: "dropdownMenu2",
  class: "dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_13 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenu2"
}
const _hoisted_14 = {
  key: 2,
  class: "form-group"
}
const _hoisted_15 = { class: "form-group form-group_phone field-dynamicmodel-phone" }
const _hoisted_16 = {
  key: 0,
  class: "help-block"
}
const _hoisted_17 = {
  key: 0,
  class: "help-block"
}
const _hoisted_18 = {
  key: 4,
  class: "auth-form__or"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imask_input = _resolveComponent("imask-input")!
  const _component_captcha = _resolveComponent("captcha")!
  const _component_socials = _resolveComponent("socials")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.clientName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(" Вход в систему: "),
          _hoisted_2,
          _createTextVNode(" «" + _toDisplayString(_ctx.clientName) + "» ", 1 /* TEXT */)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, " Вход или регистрация ")),
    (_ctx.clientDescription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.clientDescription), 1 /* TEXT */))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, " Авторизуйтесь и получите доступ ко всем возможностям проекта ")),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.error), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.configuration.isEmail && _ctx.configuration.isPhone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                (_ctx.type==='phone')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("По номеру телефона")
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.type==='email')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("По E-mail")
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("ul", _hoisted_13, [
                (_ctx.configuration.isPhone)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      class: _normalizeClass(["dropdown-item", _ctx.type==='phone' ? 'active' : '' ]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.type='phone'; _ctx.clear()})
                    }, "По номеру телефона ", 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                (_ctx.configuration.isEmail)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      class: _normalizeClass(["dropdown-item", _ctx.type==='email' ? 'active' : '' ]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.type='email'; _ctx.clear()})
                    }, "По E-mail ", 2 /* CLASS */))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.configuration.isPhone && _ctx.type==='phone')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-group form-group_phone field-phone", _ctx.inputError ? 'has-error' : ''])
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_imask_input, {
                  modelValue: _ctx.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
                  class: "form-control",
                  mask: '(000) 000-00-00',
                  radix: ".",
                  unmask: true,
                  required: "",
                  placeholder: "(000) 000-00-00",
                  onKeyup: _withKeys(_ctx.onNext, ["enter"]),
                  onChange: _ctx.onChangePhone
                }, null, 8 /* PROPS */, ["modelValue", "mask", "onKeyup", "onChange"])
              ]),
              (_ctx.inputError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.inputError), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.configuration.isEmail && _ctx.type==='email')
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(["form-group", _ctx.inputError ? '' : ''])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-group field-email", _ctx.inputError ? 'has-error' : ''])
            }, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                type: "text",
                class: "form-control",
                name: "email",
                placeholder: "Ваш личный e-mail"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.email,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.inputError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.inputError), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_captcha, {
        ref: "captcha",
        modelValue: _ctx.verifyCode,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.verifyCode) = $event)),
        value: _ctx.phone,
        "type-value": _ctx.type,
        configuration: _ctx.configuration,
        error: _ctx.captchaError,
        "on-next": _ctx.onNext
      }, null, 8 /* PROPS */, ["modelValue", "value", "type-value", "configuration", "error", "on-next"]),
      (_ctx.configuration.isPhone || _ctx.configuration.isEmail)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            id: "submit",
            class: _normalizeClass(["auth-form__btn button button-primary", {'button-loading': this.loading}]),
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
          }, "Продолжить ", 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.showOAuth())
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, "или используйте"))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_socials, { service: _ctx.service }, null, 8 /* PROPS */, ["service"])
  ], 64 /* STABLE_FRAGMENT */))
}